import { useEffect } from 'react';

const SeoJsonLd = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'LocalBusiness',
          '@id': `${siteUrl}/#business`,
          name: 'MartLed Tampa',
          description:
            "Tampa's #1 mobile LED billboard truck advertising company. Drive massive brand exposure with 2000+ daily impressions across Tampa, Florida.",
          url: siteUrl,
          logo: `${siteUrl}/favicon.png`,
          image: 'https://public.readdy.ai/ai/img_res/edited_4d0b1bfc8e632805168aa5c36ac09e61_7b0fad18.jpg',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Tampa',
            addressRegion: 'FL',
            postalCode: '33601',
            addressCountry: 'US',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 27.9506,
            longitude: -82.4572,
          },
          areaServed: [
            { '@type': 'City', name: 'Tampa', containedInPlace: { '@type': 'State', name: 'Florida' } },
            { '@type': 'Neighborhood', name: 'Ybor City' },
            { '@type': 'Neighborhood', name: 'Bayshore Boulevard' },
          ],
          priceRange: '$$',
          openingHoursSpecification: [
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
              opens: '08:00',
              closes: '22:00',
            },
          ],
          sameAs: [],
        },
        {
          '@type': 'Service',
          '@id': `${siteUrl}/#service`,
          name: 'Mobile LED Billboard Truck Advertising',
          serviceType: 'Outdoor Advertising',
          provider: { '@id': `${siteUrl}/#business` },
          areaServed: 'Tampa, Florida',
          description:
            'Mobile LED advertising trucks delivering 10K+ views per week across Tampa\'s key routes including Buccaneer Stadium, Bayshore Blvd, Ybor City, and Leto.',
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'LED Billboard Advertising Packages',
            itemListElement: [
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Starter Package',
                  description: 'Entry-level mobile LED billboard advertising in Tampa',
                },
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Pro Package',
                  description: 'Professional mobile LED billboard advertising with extended coverage',
                },
              },
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: 'Elite Package',
                  description: 'Full-city mobile LED billboard advertising domination in Tampa',
                },
              },
            ],
          },
        },
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'MartLed Tampa',
          description: "Tampa's #1 Mobile LED Billboard Truck Advertising Company",
          publisher: { '@id': `${siteUrl}/#business` },
          inLanguage: 'en-US',
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: siteUrl,
          name: 'MartLed Tampa | Mobile LED Billboard Truck Advertising Florida',
          description:
            "MartLed is Tampa's #1 mobile LED billboard truck advertising company. Drive massive brand exposure with 2000+ daily impressions.",
          isPartOf: { '@id': `${siteUrl}/#website` },
          about: { '@id': `${siteUrl}/#business` },
          inLanguage: 'en-US',
        },
      ],
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'martled-jsonld';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById('martled-jsonld');
      if (existing) existing.remove();
    };
  }, []);

  return null;
};

export default SeoJsonLd;
